import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as l, normalizeClass as n, normalizeStyle as r, createElementVNode as a } from "vue";
const c = o("joy-smile"), i = /* @__PURE__ */ a("path", {
  d: "M2185.74 479.429a117.992 117.992 0 1 0-162.829-170.852c-284.772 271.204-732.314 271.204-1017.087 0A118.05 118.05 0 0 0 842.996 479.43c375.98 358.045 966.705 358.045 1342.744 0",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function m(e, _, d, f, u, y) {
  return s(), l("svg", {
    class: n(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3072 1024",
    role: "presentation"
  }, p, 6);
}
const g = /* @__PURE__ */ t(c, [["render", m]]);
export {
  g as default
};
